var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSosNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "record_voice_over_FILL0_wght400_GRAD0_opsz24_1",
    "data-name": "record_voice_over_FILL0_wght400_GRAD0_opsz24 1",
    transform: "translate(0 -0.355)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "record_voice_over_FILL0_wght400_GRAD0_opsz24_1_Frame_Background_",
    "data-name": "record_voice_over_FILL0_wght400_GRAD0_opsz24 1 [Frame Background]",
    width: 30,
    height: 30,
    transform: "translate(0 0.355)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.968,17.581l-1.96-1.96a9.361,9.361,0,0,0,2.182-3.067,9.126,9.126,0,0,0,.79-3.763,8.91,8.91,0,0,0-.79-3.731,9.457,9.457,0,0,0-2.182-3.035L23.968,0a12.627,12.627,0,0,1,2.814,3.952A11.474,11.474,0,0,1,27.825,8.79a11.474,11.474,0,0,1-1.043,4.838,12.627,12.627,0,0,1-2.814,3.952ZM19.92,13.533,17.9,11.51a4.459,4.459,0,0,0,.917-1.217,3.417,3.417,0,0,0,0-3A4.459,4.459,0,0,0,17.9,6.071L19.92,4.047A6.666,6.666,0,0,1,21.5,6.182a6.263,6.263,0,0,1,0,5.217,6.666,6.666,0,0,1-1.581,2.134Zm-9.8.316a4.872,4.872,0,0,1-3.573-1.486A4.872,4.872,0,0,1,5.059,8.79,4.872,4.872,0,0,1,6.545,5.217a4.872,4.872,0,0,1,3.573-1.486,4.872,4.872,0,0,1,3.573,1.486A4.872,4.872,0,0,1,15.177,8.79a4.872,4.872,0,0,1-1.486,3.573A4.872,4.872,0,0,1,10.118,13.849ZM0,23.968V20.426a3.813,3.813,0,0,1,.538-1.96,3.506,3.506,0,0,1,1.486-1.391A19.8,19.8,0,0,1,5.66,15.683a16.435,16.435,0,0,1,4.458-.569,16.435,16.435,0,0,1,4.458.569,19.8,19.8,0,0,1,3.636,1.391A3.506,3.506,0,0,1,19.7,18.466a3.813,3.813,0,0,1,.538,1.96v3.541Zm2.53-2.53H17.707V20.426a1.189,1.189,0,0,0-.174-.632,1.231,1.231,0,0,0-.458-.443,20.785,20.785,0,0,0-2.925-1.138,13.256,13.256,0,0,0-4.032-.569,13.256,13.256,0,0,0-4.032.569,20.786,20.786,0,0,0-2.925,1.138,1.231,1.231,0,0,0-.458.443,1.189,1.189,0,0,0-.174.632ZM10.118,11.32a2.537,2.537,0,0,0,2.53-2.53,2.537,2.537,0,0,0-2.53-2.53,2.537,2.537,0,0,0-2.53,2.53,2.537,2.537,0,0,0,2.53,2.53Z",
    transform: "translate(1.265 2.593)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSosNewIcon);
export default __webpack_public_path__ + "static/media/SOSNewIcon.817445206b1a764540dd34d5b690f061.svg";
export { ForwardRef as ReactComponent };